module.exports = __webpack_public_path__ + "img/img_blank@2x.0926a12d.png";